import { store } from '../../redux';
import { setDataStorageNew } from '../../redux/features/dataStorage.redux';
import { getDataStorage } from '../updateDataStorage/updateDataStorage';

export const requestDataStorage = (transactionId: string) => {
  return getDataStorage(transactionId).then(async (response) => {
    store.dispatch(setDataStorageNew(response.custom));
    return response;
  });
};
